import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed, onMounted } from 'vue';
import RatingBox from '@lmt-rpb/ReviewBox/internals/RatingBox.vue';
import { scrollToAnchorWithDynamicOffset as scrollToAnchorWithDynamicOffsetOriginal, scrollIt } from '@utils/utils';
import CustomerReviewsRatingContent from './internals/CustomerReviewsRatingContent.vue';
import { gaSelectContentAttr } from 'src/utils/analytics';
import { numberFormat } from '@/js/utils/numberUtils';
import { ratingOverall } from '@utils/utils';
import { useSearchParams } from '../../composables/searchParams';

interface Props {
	ratingLabel: string;
	recommendationRate: number;
	ratingCount: number;
	ratingOverallValue: number;
	rating?: number;
	theme?: 'beforeGallery' | 'afterGallery';
	beforeGallery?: boolean;
	afterGallery?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerReviewsRatings',
  props: {
    ratingLabel: {},
    recommendationRate: {},
    ratingCount: {},
    ratingOverallValue: {},
    rating: {},
    theme: {},
    beforeGallery: { type: Boolean, default: false },
    afterGallery: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const isGalleryVariant = computed(() => props.beforeGallery || props.afterGallery);
const dynamicAttributes = computed(() => ({
	...(isGalleryVariant.value ? { href: navLink.value, ...gaSelectContentAttr({ cId: 'hotelinfo_review' }) } : {}),
}));

const urlPathname = ref('');
const urlSearchParams = useSearchParams();
const navLink = computed(() => `${urlPathname.value}${urlSearchParams.value}#reviews`);
const animationInProgress = ref(false);
const animationEndCallback = () => {
	animationInProgress.value = false;
};

const scrollToAnchorWithDynamicOffset = (event: MouseEvent): void => {
	animationInProgress.value = true;
	scrollToAnchorWithDynamicOffsetOriginal(event, animationEndCallback);
};
const blockClassModifiers = computed(() => ({
	'customer-reviews__rating--before-gallery': props.beforeGallery,
	'customer-reviews__rating--after-gallery': props.afterGallery,
}));

const recommendationRate = `${numberFormat(props.recommendationRate, 0)}%`;
const ratingFixedPerSix = ratingOverall(props.ratingOverallValue);
onMounted((): void => {
	urlPathname.value = window.location.pathname;
	const urlHash = window.location.href.split('#')[1];
	const targetElement = document.querySelector(`#${urlHash}`) as HTMLElement;
	if (targetElement) {
		setTimeout(() => {
			scrollIt(targetElement, 0, 'linear', 50);
		}, 10);
	}
});

return (_ctx: any,_cache: any) => {
  return (_ctx.ratingOverallValue)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['customer-reviews__rating', blockClassModifiers.value])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(isGalleryVariant.value ? 'a' : 'div'), _mergeProps(dynamicAttributes.value, {
          class: "customer-reviews__content",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isGalleryVariant.value && scrollToAnchorWithDynamicOffset($event)), ["prevent"]))
        }), {
          default: _withCtx(() => [
            _createVNode(CustomerReviewsRatingContent, {
              "rating-label": _ctx.ratingLabel,
              class: "customer-reviews__rating-content",
              "recommendation-rate": recommendationRate,
              "rating-count": _ctx.ratingCount
            }, null, 8 /* PROPS */, ["rating-label", "rating-count"]),
            _createVNode(RatingBox, {
              class: "customer-reviews__rating-badge",
              rating: _unref(ratingFixedPerSix)
            }, null, 8 /* PROPS */, ["rating"])
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */))
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}
}

})